import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { PaintBrushBroad } from "@phosphor-icons/react";

const FIELDS = [
  { k: "brand_name", label: "Brand Name" },
  { k: "tagline", label: "Tagline" },
  { k: "legal_name", label: "Legal Name" },
  { k: "support_email", label: "Support Email" },
  { k: "support_phone", label: "Support Phone" },
  { k: "address", label: "Address" },
  { k: "currency", label: "Currency" },
  { k: "timezone", label: "Timezone" },
];

export default function AdminBrand() {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/brand").then(({ data }) => setForm(data || {})); }, []);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    setBusy(true);
    try {
      const payload = Object.fromEntries(FIELDS.map((f) => [f.k, form[f.k] || ""]));
      await api.put("/brand", payload);
      toast.success("Brand settings saved");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Brand Settings</h1>
        <p className="mt-1 text-sm text-muted-foreground">White-label the platform. Nothing is hard-coded — change the brand without rewriting the app.</p>
      </div>

      <div className="rounded-lg border border-white/10 bg-card p-6">
        <div className="mb-4 flex items-center gap-2 text-primary"><PaintBrushBroad size={20} weight="duotone" /><span className="font-display font-semibold text-foreground">Identity</span></div>
        <div className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map((f) => (
            <div key={f.k} className={f.k === "tagline" || f.k === "address" ? "sm:col-span-2" : ""}>
              <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{f.label}</label>
              <input data-testid={`brand-${f.k}`} value={form[f.k] || ""} onChange={set(f.k)}
                className="mt-1.5 w-full rounded-md border border-white/10 bg-background px-3 py-2.5 text-sm outline-none focus:border-primary" />
            </div>
          ))}
        </div>
        <button data-testid="brand-save" onClick={save} disabled={busy}
          className="mt-6 rounded-md bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground disabled:opacity-60">
          {busy ? "Saving…" : "Save changes"}
        </button>
      </div>
    </div>
  );
}
